import { Outlet } from 'react-router-dom';
import Header from './Header';
import TabNav from './TabNav';
import ImpersonationBanner from '../debug/ImpersonationBanner';

export default function AppLayout() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <ImpersonationBanner />
      <Header />
      <TabNav />
      <main style={{ flex: 1, position: 'relative', zIndex: 1 }}>
        <Outlet />
      </main>
    </div>
  );
}
